/* eslint-disable */
/* eslint-disable id-length */
/* eslint-disable max-lines-per-function */
import React, { useEffect, useState } from 'react';
import {
  EMPLOYEE_PERFORMANCE,
  MANAGE_KPI_DASHBOARD,
} from '../../../Constants/strings';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  CircularProgress,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import NoTargetData from '../../Targets/noTarget';
import './performance.scss';
import PropTypes from 'prop-types';
import NoEmployeeDetails from '../EmployeeAchievementDetails/noEmployeeDetails';
import { getPerformanceKpiDetails } from '../../../Api/request/performance';
import UseAxios from '../../../Api/http/http';
import MultiSelectSearchDropdown from '../../../Components/MultiFilterSearch/multiFilterSearch';
import { fetchPerformancePeriodList } from './performanceUtil';
import { useSnackbar } from '../../../Components/Snackbar/snackBarProvider';

const Performance = ({ employeeId, designation, vertical, department }) => {
  const [kpiDetails, setKpiDetails] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [cycleId, setCycleId] = useState(null);
  const [performancePeriodList, setPerformancePeriodList] = useState([]);
  const [selectPerformancePeriod, setSelectPerformancePeriod] = useState([]);
  const [loading, setLoading] = useState(false);
  const { snackbarOpen } = useSnackbar();

  const dataPayload = {
    employeeId: employeeId,
    department: department,
    vertical: vertical,
    designation: designation,
    cycleId: cycleId,
  };
  useEffect(() => {
    fetchPerformancePeriodList(snackbarOpen).then(setPerformancePeriodList);
  }, []);

  useEffect(() => {
    if(selectPerformancePeriod.length == 0){
      let currentDate = new Date()
      performancePeriodList.map((perforamance) => {
        let startDate = new Date(perforamance.startDate)
        let endDate = new Date(perforamance.endDate)
        if(currentDate >= startDate && currentDate <= endDate){
          setSelectPerformancePeriod(perforamance);
          setCycleId(perforamance.id);
        }
        return null;
      });
    }
  }, [performancePeriodList]);

  const fetchPerformanceKpiDetails = async (data) => {
    setLoading(true);
    try {
      const response = await UseAxios(getPerformanceKpiDetails(data));
      setKpiDetails(response?.data?.kpiDetails);
      setLoading(false);
      return response.data;
    } catch (error) {
      console.error('Error fetching users DRI details:', error);
      setLoading(false);
      snackbarOpen(MANAGE_KPI_DASHBOARD.OOPS_TRY_AGAIN, 'warning');
      throw error;
    }
  };

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handlePerformancePeriodFilter = (event) => {
    setSelectPerformancePeriod(event.target.value);
    setCycleId(event.target.value.id);
  };

  useEffect(() => {
    if (cycleId !== null) {
      fetchPerformanceKpiDetails(dataPayload);
    }
  }, [cycleId]);

  const getClassNames = (item) => {
    if (!item) return '';
  
    const { targetFormatValue, achieved, targetValue } = item;
  
    if (achieved == null || achieved === '') {
      return 'pending'; // Class for null or empty achieved value
    }
  
    // Handle "yes" and "no" cases separately
    if (targetFormatValue === 'Yes' || targetFormatValue === 'No') {
      return achieved === targetFormatValue ? 'Achieved' : 'pending';
    }
  
    const achievedValue = parseFloat(achieved);
    const target = parseFloat(targetValue);
  
    const isAchieved = (comparison, achieved, target) => {
      switch (comparison) {
        case '>=':
          return achieved >= target;
        case '>':
          return achieved > target;
        case '<=':
          return achieved <= target;
        case '<':
          return achieved < target;
        case '=':
          if(achieved == 0 && achieved >= target){
            return true;
          }
          return achieved === target;
        default:
          return false;
      }
    };
  
    return isAchieved(targetFormatValue, achievedValue, target)
      ? 'Achieved'
      : 'pending';
  };

  const displayKpiDetails = () => {
    return kpiDetails.map((category, index) => (
      <Accordion
        expanded={expanded == `panel${index}`}
        onChange={handleAccordionChange(`panel${index}`)}
        key={category.kpiCategoryId}
        className="performance-kpi-accordion"
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls={`panel${index}bh-content`}
          id={`panel${index}bh-header`}
          className="performance-kpi-accordion-summary"
        >
          <Typography className="performance-kpi-accordion-title">
            {category.kpiCategory}
          </Typography>
        </AccordionSummary>
        <AccordionDetails className="performance-kpi-accordion-details">
          {category?.kpiOptions?.length > 0 ? (
            <TableContainer component={Paper} className="kpi-table">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell className="kpi-column-heading">
                      {EMPLOYEE_PERFORMANCE.INDICATORS}
                    </TableCell>
                    <TableCell className="target-column-heading">
                      {EMPLOYEE_PERFORMANCE.SUGGESTED}
                    </TableCell>
                    <TableCell className="target-column-heading">
                      {EMPLOYEE_PERFORMANCE.ACHIEVED}
                    </TableCell>
                    <TableCell className="remark-column-heading">
                      {EMPLOYEE_PERFORMANCE.REMARKS}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <tbody>
                  {category.kpiOptions.map((option) => (
                    <TableRow key={option.kpiId} className="kpi-option-row">
                      <TableCell className="kpi-option-name">
                        {option.kpiName}
                      </TableCell>
                      <TableCell className="kpi-option-target">
                        {option.targetFormatValue} {option.targetValue}
                      </TableCell>
                      <TableCell
                        className={`kpi-option-achieved ${getClassNames(option)}`}
                      >
                        {option.achieved ? option.achieved : '-'}
                      </TableCell>
                      <TableCell className="kpi-option-remarks">
                        <div className="remarks-container">
                          <span className="remarks-source">Source: <strong>{option.platform}</strong></span>
                          <br />
                          <span className="remarks-description">{option.description}</span>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </tbody>
              </Table>
            </TableContainer>
          ) : (
            <NoEmployeeDetails
              message={EMPLOYEE_PERFORMANCE.ERROR_MESSAGE}
              noEmployeeCss="no-performance-data"
            />
          )}
        </AccordionDetails>
      </Accordion>
    ));
  };

  return (
    <div className="performance-kpi-outer-layer">
      <div className="performance-kpi-master">
        <div className="performance-page-heading">
          <div className="performance-heading-name">
            {EMPLOYEE_PERFORMANCE.PERFORMANCE}
          </div>
          <div className='search-performance-container'>
            <MultiSelectSearchDropdown
              mode='listbox'
              dropdownCss='search-performance-period'
              options={performancePeriodList}
              value={selectPerformancePeriod}
              onChange={handlePerformancePeriodFilter}
              placeholder={MANAGE_KPI_DASHBOARD.SELECT_PLACEHOLDER.PERFORMANCE}
              autoFocus={true}
              size='small'
              showFilterIcon={false}

            />
          </div>
        </div>
        <div className="performance-kpi-detail-container">
          {loading && (
            <div className="performance-loading-indicator">
              <CircularProgress />
            </div>
          )}
          {kpiDetails?.length > 0 ? (
            displayKpiDetails()
          ) : (
            <NoTargetData message={EMPLOYEE_PERFORMANCE.NO_PERFORMANCE_DATA} />
          )}
        </div>
      </div>
    </div>
  );
};

Performance.propTypes = {
  employeeId: PropTypes.string.isRequired,
  designation: PropTypes.string.isRequired,
  vertical: PropTypes.string.isRequired,
  department: PropTypes.string.isRequired,
};

export default Performance;
